const routes = [
  {
    path: 'dashboard',
    name: 'Dashboard',
    component: () =>
      import("@/views/dashboard/Dashboard"),
  }
]

export default routes;